/** Resolve human-readable model name from vehicle payload + catalog list. */
export function resolveVehicleModelDisplayName(
  vehicle:
    | {
        model_id?: string | number;
        model?: string;
        model_name?: string;
      }
    | null
    | undefined,
  modelsList: Array<{ id?: string | number; display_name?: string; name?: string }> | undefined
): string {
  if (!vehicle) return "";
  if (vehicle.model_name) return String(vehicle.model_name);
  const mid = vehicle.model_id;
  const midStr = mid != null && mid !== "" ? String(mid) : "";
  if (vehicle.model && typeof vehicle.model === "string" && vehicle.model.trim()) {
    return vehicle.model.trim();
  }
  if (!modelsList?.length) return midStr || "—";
  const found = modelsList.find(
    (m) =>
      (m.id != null && String(m.id) === midStr) ||
      (m.display_name != null && String(m.display_name) === midStr) ||
      (m.name != null && String(m.name) === midStr)
  );
  return (
    found?.display_name ??
    found?.name ??
    (midStr || "—")
  );
}

/** Normalize plate letters for display (thin spaces between graphemes). */
export function formatPlateLettersForDisplay(raw: string | undefined | null): string {
  if (raw == null) return "";
  const compact = String(raw).replace(/\s+/g, "").trim();
  if (!compact) return "";
  return compact.split("").join("\u2009");
}
